import {
	Box,
	useTheme,
	useMediaQuery,
	Button,
	Slide,
	styled,
	ButtonProps, linearProgressClasses, LinearProgress
} from '@mui/material';
import {useTranslation} from 'react-i18next';
import React, {
	useState,
	useRef,
	useEffect,
	forwardRef,
	ReactElement,
	Ref,
	ChangeEvent
} from 'react';
import socketCompetition from '@sockets/competition';
import {TransitionProps} from '@mui/material/transitions';
import {useCompetitionWordsContext} from '@context/CompetitionWordsContext';
import ReactPlayer from 'react-player';
import media_pause from '@components/competitions/assets/images/pause-move.png';
import media_play from '@components/competitions/assets/images/play-move.png';
import media_fullscreen from '@components/competitions/assets/images/fullscreen.webp';
import bgPopup from '@components/competitions/levels/move/assets/images/bg-popup.webp';
import go from '@components/competitions/levels/move/assets/images/m1/go.webp';
import d1 from '@components/competitions/levels/move/assets/images/m1/d1.webp';
import d2 from '@components/competitions/levels/move/assets/images/m2/d2.webp';

import help from '@components/competitions/levels/move/assets/images/m2/help.webp';
import help1 from '@components/competitions/levels/move/assets/images/m2/help-1.webp';
import help2 from '@components/competitions/levels/move/assets/images/m2/help-2.webp';

import m0 from '@components/competitions/levels/move/assets/images/m2/m4.webp';
import m1 from '@components/competitions/levels/move/assets/images/m1/m1.webp';

import m2 from '@components/competitions/levels/move/assets/images/m2/m2.webp';
import m3 from '@components/competitions/levels/move/assets/images/m2/m21.webp';
import m4 from '@components/competitions/levels/move/assets/images/m2/m22.webp';


import words from './assets/words.json';
import 'react-simple-keyboard/build/css/index.css';
import screenfull from 'screenfull';
import title from '@components/competitions/levels/move/assets/images/title.webp';
import KeyboardWrapper from '@wrappers/KeyboardWrapper';
import Duration from '@components/competitions/Duration';
import MaximizableView from '@utils/MaximizableView';

type IProps = {
	state?: string
}
type PlayStopTime = {
	in: number,
	out: number
}
type Words = {
	text: string,
	hiddenCount: number,
	state: boolean,
	suggestion: number,
	playTime: [],
	stopTime: []
}
// @ts-ignore
let totalInitWords: Words[] = words;
const defaultUrl = 'https://files.novinrazavi.ir/competition/56c2f4d7-3e23-481f-9be1-f03fd737bcf0.mp4';

function compareNumbers(a: number, b: number) {
	return a - b;
}

// const randomIntArrayInRange = (min: number, text: string, n = 1) => {
// 	let max = text.length;
// 	let randomKeys = Array.from(
// 		{length: n},
// 		() => Math.floor(Math.random() * (max - min + 1)) + min
// 	);
// 	return randomKeys.sort(compareNumbers);
// };

// @ts-ignore
const randomIntArrayInRange = (min: number, text: string, n = 1) => {
	let max = text.length-1;
	let randomKeys = Array.from(
		{length: n},
		() => Math.floor(Math.random() * (max - min + 1)) + min
	);
	let randomKeysArray = randomKeys.sort(compareNumbers);
	if (text === 'ارتباط با خدا') {
		if (randomKeysArray.some(key => [6, 9].includes(key))) {
			return randomIntArrayInRange(min, text, n);
		} else {
			return randomKeysArray;
		}
	} else {
		return randomKeysArray;
	}
};

const replaceChar = (str: string, index: number, char: any) => {
	// first, convert the string to an array
	const array = str.split('');
	// then, replace the character at the specified index
	array[index] = char;
	// finally, convert the array back to a string
	return array.join('');
};

const replaceChars = (str: string, keys: number[], char: any) => {
	// first, convert the string to an array
	const array = str.split('');
	// then, replace the character at the specified index
	keys.map((key) => {
		// console.log(keys,key);
		array[key] = char;
	});
	// console.log(str, keys, array.join(''));
	// finally, convert the array back to a string
	return array.join('');
};


const Transition = forwardRef(function Transition(
	props: TransitionProps & {
		children: ReactElement<any, any>;
	},
	ref: Ref<unknown>
) {
	return <Slide direction="up" ref={ref} {...props}/>;
});
const ColorButton = styled(Button)<ButtonProps>(({theme}) => ({
	color: theme.palette.getContrastText('rgb(232 190 115)'),
	backgroundColor: 'rgb(232 190 115)',
	'&:hover': {
		backgroundColor: 'rgb(232 190 115)'
	}
}));
type WordsList = {
	index: number,
	content: string,
	randomKeys: number[]
}
let initWordIndex = 0;
let selectedWord = totalInitWords[initWordIndex];
export default function Mission2(props: IProps) {
	const {state} = props;
	
	const theme = useTheme();
	const {t} = useTranslation();
	const {
		setMission
	} = useCompetitionWordsContext();
	// -----------
	const player = useRef<ReactPlayer>(null);
	const keyboard = useRef(null);
	const [totalWords, setTotalWords] = useState(totalInitWords);
	const [initWord, setInitWord] = useState(selectedWord);
	const [wordIndex, setWordIndex] = useState<number>(initWordIndex);
	const [randomKeys, setRandomKeys] = useState(randomIntArrayInRange(0, initWord.text, initWord.hiddenCount));
	const [content, setContent] = useState(replaceChars(initWord.text, randomKeys, '_'));
	const [newContent, setNewContent] = useState(content);
	const [currentSeekIndex, setCurrentSeekIndex] = useState<number | null>(null);
	const [dialogMode, setDialogMode] = useState<number>(1);
	const [totalAnswer, setTotalAnswer] = useState<number>(0);
	const [showDialog, setShowDialog] = useState<boolean>(true);
	const [wordError, setWordError] = useState<boolean>(false);
	const [wordErrorArray, setWordErrorArray] = useState<string[]>([]);
	const [progress, setProgress] = useState(0);
	const [remaining, setRemaining] = useState(0);
	const [url, setUrl] = useState('');
	const [isPlaying, setIsPlaying] = useState(false);
	const [buffer, setBuffer] = useState(10);
	const [playedIndex, setPlayedIndex] = useState(0);
	const [duration, setDuration] = useState(0);
	const [showDescDialog, setShowDescDialog] = useState(true);
	const [showHelpDialog, setShowHelpDialog] = useState(false);
	
	useEffect(() => {
		setInitWord(totalWords[wordIndex]);
	}, [wordIndex]);
	
	useEffect(() => {
		setUrl(defaultUrl);
	}, [url]);
	
	useEffect(() => {
		let newRandomKeys = randomIntArrayInRange(0, initWord.text, initWord.hiddenCount);
		let newContent = replaceChars(initWord.text, newRandomKeys, '_');
		setRandomKeys(() => newRandomKeys);
		setContent(() => newContent);
		setNewContent(() => newContent);
	}, [initWord]);
	
	useEffect(() => {
		if (totalAnswer >= 3) {
			setDialogMode(4);
			setShowDialog(true);
		}
	}, [totalAnswer]);
	
	useEffect(() => {
		let currentTime = player.current?.getCurrentTime() as number;
		if (currentSeekIndex !== null) {
			let playtime = totalWords[currentSeekIndex].playTime;
			let stopTime = playtime[playedIndex][1] as number;
			if (dialogMode === 3 && currentTime >= stopTime) {
				setIsPlaying(false);
			}
		}
	}, [progress]);
	
	/*	useEffect(() => {
	 // const randomKeys = useMemo(() => randomIntArrayInRange(1, text, hiddenCount), [text]);
	 // randomKeys = randomIntArrayInRange(1, text, hiddenCount);
	 // const content = useMemo(() => replaceChars(text, randomKeys, '_'), [hiddenCount]);
	 // content = replaceChars(text, randomKeys, '_');
	 // setNewContent(() => content);
	 }, []);*/
	
	const addChar = (chr: string) => {
		// console.log(chr);
		// setInputChar(chr);
	};
	const compareCharWithText = () => {
		/*if (wordErrorArray.length == 1) {
		 setDialogMode(0);
		 setShowDialog(true);
		 }*/
		if (initWord.text === newContent) {
			setTotalWords((prevState) => {
				let newState: Words[] = Object.assign([], [...prevState]);
				newState[wordIndex].state = true;
				return newState;
			});
			if (wordIndex + 1 < totalWords.length) {
				setWordIndex((wordIndex) => wordIndex + 1);
			} else {
				setDialogMode(2);
				setShowDialog(true);
			}
			setWordError(false);
			setWordErrorArray([]);
		} else {
			setWordError(true);
			setDialogMode(0);
			setShowDialog(true);
			/*	if (!wordErrorArray.includes(newContent)) {
			 setWordErrorArray((prev) => [...prev, newContent]);
			 }*/
			setNewContent(() => content);
		}
	};
	const onKeyReleased = (chr: string) => {
		if (!['{space}', '{del}', '{ent}'].includes(chr)) {
			setNewContent(() => newContent.replace('_', chr));
		} else {
			if (chr === '{space}') {
				setNewContent(() => newContent.replace('_', ' '));
			}
			if (chr === '{del}') {
				setNewContent(() => content);
				setWordError(false);
			}
			if (chr === '{ent}') {
				compareCharWithText();
			}
		}
		// setInputChar(chr);
		// let inputCharSplit = chr.split('');
		// if (inputCharSplit.length > 0) {
		// }
	};
	
	const changeSeek = (index: number) => {
		totalWords[index].suggestion = -1;
		let playtime = totalWords[index].playTime;
		setCurrentSeekIndex(index);
		let randomPlayTime = Math.floor(Math.random() * (playtime.length));
		setPlayedIndex(randomPlayTime);
		player.current?.seekTo(playtime[randomPlayTime][0] as number);
		if (showDescDialog) {
			setIsPlaying(false);
			setDialogMode(3);
			setShowDialog(true);
		} else {
			setIsPlaying(true);
		}
		setShowDescDialog(false);
	};
	
	const onPlayClick = () => {
		// props.playerRef?
		if (currentSeekIndex !== null) {
			setIsPlaying(() => !isPlaying);
		}
	};
	
	function onPause() {
		let currentTime = player.current?.getCurrentTime() as number;
		// console.log(player.current?.getDuration());
		// console.log('currentTime', currentTime);
		// console.log('currentSeekIndex', currentSeekIndex);
		if (currentSeekIndex !== null) {
			let stopTime = totalWords[currentSeekIndex].stopTime[playedIndex];
			// console.log('stopTime', stopTime);
			let found = 0;
			for (let i of stopTime as []) {
				if (i[0] <= currentTime && currentTime <= i[1]) {
					found = 1;
				}
			}
			if (found === 1) {
				setTotalAnswer((prev) => prev + 1);
				setTotalWords((prevState) => {
					let newState: Words[] = Object.assign([], [...prevState]);
					newState[currentSeekIndex].suggestion = 1;
					return newState;
				});
			} else if (found === 0) {
				setTotalWords((prevState) => {
					let newState: Words[] = Object.assign([], [...prevState]);
					newState[currentSeekIndex].suggestion = 0;
					return newState;
				});
			}
			setCurrentSeekIndex(null);
		}
	}
	
	function onEnded() {
		// if (dialogMode === 1) {
		// 	setIsPlaying(false);
		// 	setShowDialog(true);
		// }
	}
	
	const BorderLinearProgress = styled(LinearProgress)(({theme}) => ({
		height: 5,
		borderRadius: 5,
		'&.MuiLinearProgress-colorPrimary:not(.MuiLinearProgress-buffer)': {
			backgroundColor: '#0b152b'
		},
		'& .MuiLinearProgress-colorPrimary': {
			backgroundColor: theme.palette.mode === 'light' ? '#62b694' : '#62b694'
		},
		'& .MuiLinearProgress-barColorPrimary': {
			backgroundColor: '#0b152b'
		},
		'& .MuiLinearProgress-buffer': {
			backgroundColor: '#0b152b'
		},
		'& .MuiLinearProgress-bar1Buffer': {
			backgroundColor: '#0b152b'
		},
		// ['& .MuiLinearProgress-dashedColorPrimary']: {
		// 	backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800]
		// 	// 'radial-gradient(#3d73e8 0%, #3d73e8 16%, transparent 42%)'
		// },
		[`&.${linearProgressClasses.colorPrimary}`]: {
			backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800]
		}
		// [`& .${linearProgressClasses.bar}`]: {
		// 	borderRadius: 5,
		// 	backgroundColor: theme.palette.mode === 'light' ? '#0b152b' : '#0b152b'
		// }
	}));
	
	function onProgress(value: any) {
		let remaining = duration * (1 - value.played);
		setProgress(100 * value.played);
		setBuffer(100 * value.loaded);
		setRemaining(remaining);
	}
	
	const helpAction = () => {
		setShowHelpDialog(true);
	};
	
	return (
		<>
			<div className="chat-words-choice h-full flex flex-col justify-between px-5">
				<div className="flex flex-col w-full justify-center items-center mt-10 gap-y-3">
					<img className="w-3/6" src={title} alt="title"/>
				</div>
				{
					dialogMode !== 1 && dialogMode !== 0 && (
						<div className="w-full h-auto">
							<MaximizableView backgroundColor="#efefef" help={true} helpAction={helpAction}>
								<Box className="w-full flex flex-col justify-center items-center">
									<div
										className={`video-wrapper w-full h-auto m-auto rounded-2xl border-2 mt-10 ${currentSeekIndex !== null ? 'cursor-pointer' : ''}`}
										onClick={() => {
											if (currentSeekIndex !== null) {
												onPlayClick();
											}
										}}>
										<ReactPlayer
											width={'100%'}
											height={'100%'}
											// ref={props.playerRef}
											ref={player}
											// ref={videoPlayerRef}
											controls={false}
											className="react-player outline-none rounded-2xl overflow-hidden"
											url={url}
											playing={isPlaying}
											onPause={onPause}
											onEnded={onEnded}
											onProgress={onProgress}
											onDuration={setDuration}
											// onSeek={handleSeekChange}
											// onSeek={e => console.log('onSeek', e)}
											// height={props.height}
											// width={props.width}
											// loop={true}
											// controls={true}
											// url={props.file}
											// playIcon={<PlayArrowIcon/>}
										/>
									
									</div>
									<div className="w-full flex flex-col items-center justify-between">
										<div className="w-full h-8 flex flex-row ltr justify-center items-center mt-2 content-center">
											<div
												className={`w-8 h-auto p-2 flex flex-col content-center justify-center items-center bg-white rounded-full ${currentSeekIndex !== null ? 'cursor-pointer' : ''}`}
												onClick={() => {
													if (currentSeekIndex !== null) {
														onPlayClick();
													}
												}}
											>
												{isPlaying ?
													<img src={media_pause} alt={'media_pause'} className="w-3 h-auto"/> :
													<img src={media_play} alt={'media_play'} className="w-3 h-auto"/>}
											</div>
											<div className="w-11/12 mx-2">
												<BorderLinearProgress
													variant="buffer"
													value={progress}
													valueBuffer={buffer}
													sx={{
														direction: 'ltr'
													}}
												/>
												{/*<LinearProgress
												 variant={'buffer'}
												 value={progress}
												 valueBuffer={buffer}
												 classes={{
												 barColorPrimary: '#0b152b'
												 }}
												 />*/}
											</div>
										</div>
										{/*<div className="cursor-pointer" onClick={() => {*/}
										{/*	toggleFullScreen();*/}
										{/*}}>*/}
										{/*	<img src={media_fullscreen} alt={'media_fullscreen'} className="w-24 h-auto mt-8"/>*/}
										{/*</div>*/}
									</div>
								</Box>
							</MaximizableView>
						</div>
					)
				}
				{/*{*/}
				{/*	dialogMode !== 2 && (*/}
				<div className="w-5/6 flex justify-center items-center mt-3 mb-3 rounded-2xl mx-auto">
					<img className="w-full" src={[d1, d1, d2, d2, d2][dialogMode]} alt="title"/>
				</div>
				{/*)*/}
				{/*}*/}
				<Box
					className={`flex flex-col flex-wrap justify-center items-center ${dialogMode > 1 ? 'mt-5' : 'mt-2'}`}>
					<div className="w-full flex flex-row gap-2 flex-wrap justify-center">
						{
							totalWords.length > 0 ? (
								totalWords.map((word, index) => {
									return (
										word.state ? (
											<div key={`word_${index}`}
											     onClick={() => (dialogMode > 1 && word.suggestion !== 1) ? changeSeek(index) : null}
											     className={
												     `flex flex-grow-0 basis-28 shrink w-fit h-8 font-bold rounded-2xl p-2 text-center items-center justify-center text-white text-sm ${
													     word.suggestion === -1 ?
														     (currentSeekIndex === index && dialogMode === 3) ?
															     'bg-[#0b152b] cursor-pointer border-2 border-white' : 'bg-[#0b152b] cursor-pointer border-2 border-[#0b152b]' :
														     word.suggestion === 0 ? 'bg-red-400 cursor-pointer' :
															     word.suggestion === 1 ? 'bg-green-800 pulseAnimate' : null
												     }`
											     }
											>{word.text}</div>
										) : (
											<div key={`word_${index}`}
											     className="flex basis-28 bg-[#0b152b] h-8 rounded-2xl justify-center items-center text-center">
												<div className="blur">---</div>
											</div>
										)
									);
								})
							) : null
						}
					</div>
				</Box>
				{
					dialogMode < 2 && (
						<Box className="w-full ltr mb-2 py-3 scaleHelpAnimate">
							<div
								className={`flex justify-center text-center rounded-2xl h-10 items-center rtl ${wordError ? 'bg-red-200' : 'bg-gray-100'}`}>
								{newContent}
							</div>
							{/*<KeyboardWrapper keyboardRef={keyboard} onChange={addChar}/>*/}
							<div className="mt-2">
								<KeyboardWrapper keyboardRef={keyboard} onChange={addChar} onKeyReleased={onKeyReleased}/>
							</div>
						</Box>
					)
				}
				{
					dialogMode > 1 && (
						<Box className="flex flex-col w-full py-5 gap-y-5 items-right justify-center mb-5">
							<div className="flex flex-row w-full">
								<div className="w-12 h-12 rounded-full flex justify-center items-center bg-[#0b152b]">
									<img src={help} alt={'help'} className="w-10 h-auto"/>
								</div>
								<div className="flex-1 rounded-3xl bg-[#62B694] p-3 flex justify-center items-center">
									<img src={help1} alt={'help1'} className="w-full"/>
								</div>
							</div>
							<div className="flex flex-row w-5/6 justify-center items-center">
								<div className="w-12 h-12 rounded-full flex justify-center items-center bg-[#0b152b]">
									<img src={help} alt={'help'} className="w-10 h-auto"/>
								</div>
								<div className="flex-1 h-10 rounded-3xl bg-[#62B694] p-3 flex justify-center items-center">
									<img src={help2} alt={'help2'} className="w-full"/>
								</div>
							</div>
						</Box>
					)
				}
			</div>
			{
				showDialog && (
					<Box className="w-full h-full bg-white/90 absolute top-[55px] right-0 bottom-0 left-0">
						<Box
							// sx={{
							// 	backgroundImage: `url(${bgPopup})`,
							// 	backgroundRepeat: 'no-repeat',
							// 	backgroundSize: 'contain'
							// }}
							className={`w-5/6 h-auto mx-auto relative top-[30%] ${dialogMode == 0 || dialogMode == 3 ? 'bg-[#62b694]' : 'bg-[#081628]'} rounded-3xl`}
						>
							<div className="flex flex-col w-full h-auto justify-center items-center gap-y-5 p-4">
								<div className="w-full">
									{/*<img className="w-full" src={dialogMode === 1 ? m1 : m2} alt="title"/>*/}
									<img className="w-full" src={[m0, m1, m2, m3, m4][dialogMode]} alt="title"/>
								</div>
								<div className="w-1/4">
									<div className="w-5/6 bg-white rounded-2xl p-2 cursor-pointer" onClick={() => {
										setShowDialog(false);
										if (dialogMode == 3) {
											setIsPlaying(true);
										}
										if (dialogMode == 4) {
											setMission(3);
										}
										// if (dialogMode == 2) {
										// 	setDialogMode(3);
										// } else {
										// 	setShowDialog(false);
										// }
									}}>
										<img className="w-full" src={go} alt="title"/>
									</div>
								</div>
							</div>
						</Box>
					</Box>
				)
			}
			{
				showHelpDialog && (
					<Box className="w-full h-full bg-white/90 absolute top-[55px] right-0 bottom-0 left-0">
						<Box
							// sx={{
							// 	backgroundImage: `url(${bgPopup})`,
							// 	backgroundRepeat: 'no-repeat',
							// 	backgroundSize: 'contain'
							// }}
							className={`w-5/6 h-auto mx-auto relative top-[30%] ${dialogMode == 0 || dialogMode == 3 ? 'bg-[#62b694]' : 'bg-[#081628]'} rounded-3xl`}
						>
							<div className="flex flex-col w-full h-auto justify-center items-center gap-y-5 p-4">
								<div className="w-full text-white select-none">
									<div>
										اول روی اون کلمه ای که حدس زدی و کامل کردی کلیک کن.
										بخشی از فیلم برات پخش می شه و هرجای فیلم که فکر می کنی معنای کلمه حدس زده رو نشون می ده، فیلم رو استاپ
										کن.
									</div>
									<div>
										اگر درست حدس زده باشی کلید سبز میشه و می تونی بری سراغ بعدی
									</div>
								</div>
								<div className="w-1/4">
									<div className="w-5/6 bg-white rounded-2xl p-2 cursor-pointer select-none" onClick={() => {
										setShowHelpDialog(false);
										// if (dialogMode == 2) {
										// 	setDialogMode(3);
										// } else {
										// 	setShowDialog(false);
										// }
									}}>
										<img className="w-full select-none" src={go} alt="title"/>
									</div>
								</div>
							</div>
						</Box>
					</Box>
				)
			}
		</>
	);
}
// replaceChars(totalWords[wordIndex].text, randomIntArrayInRange(1, totalWords[wordIndex].text, totalWords[wordIndex].hiddenCount), ' _ ');
